export var DedicationsTrans = [
  {
    id: 1.0,
    label_czech: "Jméno Panny Marie",
    label_english: "Name of the Virgin Mary",
  },
  { id: 2.0, label_czech: "Loreta", label_english: "Loreta" },
  { id: 3.0, label_czech: "Matka Boží", label_english: "Mother of God" },
  {
    id: 4.0,
    label_czech: "Nanebevzetí Panny Marie",
    label_english: "Assumption of the Virgin Mary",
  },
  {
    id: 5.0,
    label_czech: "Narození Panny Marie",
    label_english: "Nativity of the Blessed Virgin Mary",
  },
  {
    id: 6.0,
    label_czech: "Navštívení Panny Marie",
    label_english: "Visitation of the Virgin Mary",
  },
  {
    id: 7.0,
    label_czech: "Navštívení Panny Marie u sv. Alžběty v horách",
    label_english:
      "Visitation of the Virgin Mary at St. Elizabeth in the Mountains",
  },
  {
    id: 8.0,
    label_czech: "Nejsvětější Rodička Boží Maria",
    label_english: "Our Most Holy Lady Theotokos",
  },
  {
    id: 9.0,
    label_czech: "Panna Maria Bohorodička",
    label_english: "Virgin Mary Theotokos",
  },
  {
    id: 10.0,
    label_czech: "Neposkvrněné početí Panny Marie",
    label_english: "Immaculate Conception",
  },
  {
    id: 11.0,
    label_czech: "Matka Boží Loretánská",
    label_english: "Mother of God of Loreto",
  },
  {
    id: 12.0,
    label_czech: "Panna Maria Loretánská",
    label_english: "Our Lady of Loreto",
  },
  {
    id: 13.0,
    label_czech: "Obětování Panny Marie",
    label_english: "Sacrifice of the Virgin Mary",
  },
  { id: 14.0, label_czech: "Panna Maria", label_english: "Virgin Mary" },
  {
    id: 15.0,
    label_czech: "Panna Maria Altöttingská",
    label_english: "Our Lady of Altötting",
  },
  {
    id: 16.0,
    label_czech: "Panna Maria Andělská",
    label_english: "Saint Mary of the Angels",
  },
  {
    id: 17.0,
    label_czech: "Panna Maria Bolestná",
    label_english: "Our Lady of Sorrows",
  },
  {
    id: 18.0,
    label_czech: "Panna Maria Sedmibolestná",
    label_english: "Our Lady of the Seven Sorrows",
  },
  {
    id: 19.0,
    label_czech: "Panna Maria Karmelská",
    label_english: "Our Lady of Mount Carmel",
  },
  {
    id: 20.0,
    label_czech: "Panna Maria Královna andělů",
    label_english: "Our Lady Queen of the Angels",
  },
  {
    id: 21.0,
    label_czech: "Panna Maria Královna Míru",
    label_english: "Our Lady of Peace",
  },
  {
    id: 22.0,
    label_czech: "Panna Maria na písku",
    label_english: "Our Lady on the Sand",
  },
  {
    id: 23.0,
    label_czech: "Panna Maria Neposkvrněná",
    label_english: "Our Lady Immaculate",
  },
  {
    id: 24.0,
    label_czech: "Panna Maria pod ochranou Božské Prozřetelnosti",
    label_english: "Our Lady under the protection of Divine Providence",
  },
  {
    id: 25.0,
    label_czech: "Panna Maria pod řetězem konce mosta",
    label_english: "Our Lady beneath the Chain",
  },
  {
    id: 26.0,
    label_czech: "Panna Maria Pomocná",
    label_english: "Our Lady Help of Christians",
  },
  {
    id: 27.0,
    label_czech: "Panna Maria Pomocnice křestanů",
    label_english: "Our Lady Help of Christians",
  },
  {
    id: 28.0,
    label_czech: "Panna Maria Ustavičné pomoci",
    label_english: "Our Lady of Perpetual Help",
  },
  {
    id: 29.0,
    label_czech: "Panna Maria Růžencová",
    label_english: "Our Lady of the Rosary",
  },
  {
    id: 30.0,
    label_czech: "Panna Maria Sněžná",
    label_english: "Saint Mary of the Snows",
  },
  {
    id: 31.0,
    label_czech: "Panna Maria Utěšitelka",
    label_english: "Our Lady of Consolation",
  },
  {
    id: 32.0,
    label_czech: "Panna Maria Uzdravení nemocných",
    label_english: "Our Lady of Healing",
  },
  {
    id: 33.0,
    label_czech: "Panna Maria Vítězná",
    label_english: "Our Lady of Victories",
  },
  {
    id: 34.0,
    label_czech: "Zasnoubení Panny Marie",
    label_english: "The Betrothal of the Virgin Mary",
  },
  {
    id: 35.0,
    label_czech: "Zvěstování Panně Marii",
    label_english: "Annunciation of Our Lady",
  },
  {
    id: 36.0,
    label_czech: "Zvěstování Panny Marie",
    label_english: "Annunciation of Our Lady",
  },
  { id: 37.0, label_czech: "Boží Tělo", label_english: "Corpus Christi" },
  {
    id: 38.0,
    label_czech: "Božího Milosrdenství",
    label_english: "Divine Mercy",
  },
  {
    id: 39.0,
    label_czech: "Božské Srdce Páně",
    label_english: "Sacred Heart Church",
  },
  {
    id: 40.0,
    label_czech: "Nejsvětější Srdce Páně",
    label_english: "The Most Sacred Heart Church",
  },
  { id: 41.0, label_czech: "ke cti Boží", label_english: "Glory of God" },
  {
    id: 42.0,
    label_czech: "Narození Páně",
    label_english: "Nativity of Christ",
  },
  { id: 43.0, label_czech: "Nejsvětější Trojice", label_english: "Trinity" },
  {
    id: 44.0,
    label_czech: "Proměnění Páně",
    label_english: "Transfiguration of Jesus",
  },
  { id: 45.0, label_czech: "Spasitel", label_english: "Holy Saviour" },
  { id: 46.0, label_czech: "sv. Salvátor", label_english: "St. Salvator" },
  {
    id: 47.0,
    label_czech: "Zmrtvýchvstání Páně",
    label_english: "Resurrection of the Lord",
  },
  {
    id: 48.0,
    label_czech: "Zvěstování Páně",
    label_english: "Annunciation of the Lord",
  },
  { id: 49.0, label_czech: "sv. Duch", label_english: "Holy Spirit" },
  { id: 50.0, label_czech: "Andělé strážní", label_english: "Guardian Angels" },
  {
    id: 51.0,
    label_czech: "sv. Archanděl Michael",
    label_english: "St. Michael the Archangel",
  },
  {
    id: 52.0,
    label_czech: "Nalezení sv. Kříže",
    label_english: "Finding of the Cross",
  },
  {
    id: 53.0,
    label_czech: "Povýšení sv. Kříže",
    label_english: "Exaltation of the Holy Cross",
  },
  { id: 54.0, label_czech: "sv. Kříž", label_english: "Holy Cross" },
  { id: 55.0, label_czech: "sv. Kříž Větší", label_english: "Holy Cross" },
  {
    id: 56.0,
    label_czech: "Čtrnáct svatých pomocníků",
    label_english: "Fourteen Holy Helpers",
  },
  { id: 57.0, label_czech: "svaté schody", label_english: "Holy Stairs" },
  { id: 58.0, label_czech: "Všech svatých", label_english: "All Saints" },
  {
    id: 59.0,
    label_czech: "Svatí patroni čeští",
    label_english: "Patron Saints of Bohemia",
  },
  {
    id: 60.0,
    label_czech: "sv. Anežka",
    label_english: "St. Agnes of Bohemia",
  },
  {
    id: 61.0,
    label_czech: "Sv. Cyril a Metoděj",
    label_english: "Ss. Cyril and Methodius",
  },
  {
    id: 62.0,
    label_czech: "sv. Jan Nepomucký",
    label_english: "St. John of Nepomuk",
  },
  {
    id: 63.0,
    label_czech: "sv. Ludmila",
    label_english: "St. Ludmila of Bohemia",
  },
  { id: 64.0, label_czech: "sv. Václav", label_english: "St. Wenceslaus" },
  { id: 65.0, label_czech: "sv. Vít", label_english: "St. Vitus" },
  {
    id: 66.0,
    label_czech: "sv. Vojtěch",
    label_english: "St. Adalbert of Prague",
  },
  {
    id: 67.0,
    label_czech: "sv. Zdislava",
    label_english: "St. Zdislava of Lemberk",
  },
  {
    id: 68.0,
    label_czech: "sv. Kliment",
    label_english: "St. Clement of Rome",
  },
  {
    id: 69.0,
    label_czech: "sv. Norbert",
    label_english: "St. Norbert of Xanten",
  },
  {
    id: 70.0,
    label_czech: "sv. Prokop",
    label_english: "St. Procopius of Sázava",
  },
  {
    id: 71.0,
    label_czech: "bl. Juliána Collalti",
    label_english: "Giuliana of Collato",
  },
  {
    id: 72.0,
    label_czech: "Stigmatizace sv. Františka",
    label_english: "Stigmata of St. Francis",
  },
  { id: 73.0, label_czech: "sv. Alexius", label_english: "St. Alexius" },
  {
    id: 74.0,
    label_czech: "sv. Alfons z Liguori",
    label_english: "St. Alphonsus Liguori",
  },
  { id: 75.0, label_czech: "sv. Alžběta", label_english: "St. Elisabeth" },
  { id: 76.0, label_czech: "sv. Ambrož", label_english: "St. Ambrose" },
  {
    id: 77.0,
    label_czech: "sv. Anežka Římská",
    label_english: "St. Agnes of Rome",
  },
  { id: 78.0, label_czech: "sv. Anna", label_english: "St. Anne" },
  { id: 79.0, label_czech: "sv. Antonín", label_english: "St. Anthony" },
  {
    id: 80.0,
    label_czech: "sv. Antonín Paduánský",
    label_english: "St. Anthony of Padua",
  },
  {
    id: 81.0,
    label_czech: "sv. Apolinář",
    label_english: "St. Apollinaris of Ravenna",
  },
  {
    id: 82.0,
    label_czech: "sv. Augustin",
    label_english: "St. Augustine of Hippo",
  },
  { id: 83.0, label_czech: "sv. Barbora", label_english: "St. Barbara" },
  { id: 84.0, label_czech: "sv. Bartoloměj", label_english: "St. Bartholomew" },
  { id: 85.0, label_czech: "sv. Benedikt", label_english: "St. Benedict" },
  { id: 86.0, label_czech: "sv. Bernard", label_english: "St. Bernard" },
  { id: 87.0, label_czech: "sv. Bernardin", label_english: "St. Bernardino" },
  {
    id: 88.0,
    label_czech: "sv. Bernardin Sienský",
    label_english: "St. Bernardino of Siena",
  },
  {
    id: 89.0,
    label_czech: "sv. Bonaventura",
    label_english: "St. Bonaventure",
  },
  { id: 90.0, label_czech: "sv. Bonifác", label_english: "St. Boniface" },
  { id: 91.0, label_czech: "sv. Bruno", label_english: "St. Bruno" },
  {
    id: 92.0,
    label_czech: "sv. Dionysius z Paříže",
    label_english: "St. Denis of Paris",
  },
  { id: 93.0, label_czech: "sv. Dominik", label_english: "St. Dominic" },
  { id: 94.0, label_czech: "sv. Fabián", label_english: "St. Fabian" },
  {
    id: 95.0,
    label_czech: "sv. Faustyna",
    label_english: "St. Faustina Kowalska",
  },
  {
    id: 96.0,
    label_czech: "sv. Felix z Cantalice",
    label_english: "St. Felix of Cantalice",
  },
  {
    id: 97.0,
    label_czech: "sv. Filip a Jakub",
    label_english: "Ss. Philip and James",
  },
  { id: 98.0, label_czech: "sv. František", label_english: "St. Francis" },
  {
    id: 99.0,
    label_czech: "sv. František Serafínský",
    label_english: "St. Francis of Seraphim",
  },
  {
    id: 100.0,
    label_czech: "sv. František Xaverský",
    label_english: "St. Francis Xavier",
  },
  {
    id: 101.0,
    label_czech: "sv. František z Pauly",
    label_english: "St. Francis of Paola",
  },
  { id: 102.0, label_czech: "sv. Gotthard", label_english: "St. Gotthard" },
  { id: 103.0, label_czech: "sv. Haštal", label_english: "St. Castulus" },
  { id: 104.0, label_czech: "sv. Havel", label_english: "St. Gall" },
  {
    id: 105.0,
    label_czech: "sv. Hedvika Slezská",
    label_english: "St. Hedwig of Silesia",
  },
  { id: 106.0, label_czech: "sv. Hypolit", label_english: "St. Hypolitus" },
  {
    id: 107.0,
    label_czech: "sv. Ignác",
    label_english: "St. Ignatius of Loyola",
  },
  {
    id: 108.0,
    label_czech: "sv. Ivan Poustevník",
    label_english: "St. Ivan the Hermit",
  },
  { id: 109.0, label_czech: "sv. Jakub", label_english: "St. James" },
  {
    id: 110.0,
    label_czech: "sv. Jakub Starší",
    label_english: "St. James the Elder",
  },
  {
    id: 111.0,
    label_czech: "sv. Jakub Větší",
    label_english: "St. James the Great",
  },
  {
    id: 112.0,
    label_czech: "sv. Jan Evangelista",
    label_english: "St. John the Evangelist",
  },
  {
    id: 113.0,
    label_czech: "sv. Jan Křtitel",
    label_english: "St. John the Baptist",
  },
  {
    id: 114.0,
    label_czech: "sv. Jan Křtitel na poušti",
    label_english: "St. John the Baptist in the desert",
  },
  {
    id: 115.0,
    label_czech: "sv. Jan Zlatoústý",
    label_english: "St. John Chrysostom",
  },
  { id: 116.0, label_czech: "sv. Jeroným", label_english: "St. Jerome" },
  { id: 117.0, label_czech: "sv. Jiljí", label_english: "St. Giles" },
  { id: 117.1, label_czech: "sv. Jiří", label_english: "St. George" },
  {
    id: 118.0,
    label_czech: "sv. John Ogilvie",
    label_english: "St. John Ogilvie",
  },
  { id: 119.0, label_czech: "sv. Josef", label_english: "St. Joseph" },
  {
    id: 120.0,
    label_czech: "sv. Josef Kalasanský",
    label_english: "St. Joseph Calasanz",
  },
  { id: 121.0, label_czech: "sv. Kajetán", label_english: "St. Cajetan" },
  {
    id: 122.0,
    label_czech: "sv. Karel Boromejský",
    label_english: "St. Charles Borromeo",
  },
  {
    id: 123.0,
    label_czech: "sv. Karel Veliký",
    label_english: "St. Charlemagne",
  },
  { id: 124.0, label_czech: "sv. Kateřina", label_english: "St. Catherine" },
  { id: 125.0, label_czech: "sv. Kilián", label_english: "St. Kilian" },
  {
    id: 126.0,
    label_czech: "sv. Klement Maria Hofbauer",
    label_english: "St. Clement Mary Hofbauer",
  },
  {
    id: 127.0,
    label_czech: "sv. Kunhuta",
    label_english: "St. Cunigunde of Luxembourg",
  },
  {
    id: 128.0,
    label_czech: "sv. Lazar",
    label_english: "St. Lazarus of Bethany",
  },
  { id: 129.0, label_czech: "sv. Leopold", label_english: "St. Leopold" },
  { id: 130.0, label_czech: "sv. Linhart", label_english: "St. Leonard" },
  { id: 131.0, label_czech: "sv. Marek", label_english: "St. Mark" },
  { id: 132.0, label_czech: "sv. Markéta", label_english: "St. Margaret" },
  { id: 133.0, label_czech: "sv. Martin", label_english: "St. Martin" },
  {
    id: 134.0,
    label_czech: "sv. Máří Magdalena",
    label_english: "St. Mary Magdalene",
  },
  { id: 135.0, label_czech: "sv. Matěj", label_english: "St. Matthias" },
  { id: 136.0, label_czech: "sv. Materna", label_english: "St. Maternus" },
  { id: 137.0, label_czech: "sv. Matouš", label_english: "St. Matthew" },
  {
    id: 138.0,
    label_czech: "sv. Matouš Evangelista",
    label_english: "St. Matthew the Evangelist",
  },
  { id: 139.0, label_czech: "sv. Michael", label_english: "St. Michael" },
  { id: 140.0, label_czech: "sv. Michal", label_english: "St. Michael" },
  { id: 141.0, label_czech: "sv. Mikuláš", label_english: "St. Nicholas" },
  {
    id: 142.0,
    label_czech: "sv. Mikuláš Tolentinský",
    label_english: "St. Nicholas of Tolentino",
  },
  { id: 143.0, label_czech: "sv. Modest", label_english: "St. Modestus" },
  { id: 144.0, label_czech: "sv. Ondřej", label_english: "St. Andrew" },
  { id: 145.0, label_czech: "sv. Pavel", label_english: "St. Paul" },
  { id: 146.0, label_czech: "sv. Petr", label_english: "St. Peter" },
  {
    id: 147.0,
    label_czech: "sv. Petr a Pavel",
    label_english: "Ss. Peter and Paul",
  },
  {
    id: 148.0,
    label_czech: "sv. Petr Celestin",
    label_english: "St. Peter Celestine",
  },
  { id: 149.0, label_czech: "sv. Rodina", label_english: "Holy Family" },
  { id: 150.0, label_czech: "sv. Roch", label_english: "St. Roch" },
  { id: 151.0, label_czech: "sv. Rosalie", label_english: "St. Rosalia" },
  { id: 152.0, label_czech: "sv. Šebestián", label_english: "St. Sebastian" },
  {
    id: 153.0,
    label_czech: "sv. Šimon a Juda",
    label_english: "Ss. Simon the Zealot and Jude",
  },
  { id: 154.0, label_czech: "sv. Štěpán", label_english: "St. Stephen " },
  {
    id: 155.0,
    label_czech: "sv. Štěpán Prvomučedník",
    label_english: "St. Stephen Protomartyr",
  },
  {
    id: 156.0,
    label_czech: "sv. Teresie od Dítěte Ježíše a od Svaté Tváře",
    label_english: "St. Therese of the Child Jesus and the Holy Face",
  },
  { id: 157.0, label_czech: "sv. Tomáš", label_english: "St. Thomas" },
  { id: 158.0, label_czech: "sv. Tři králové", label_english: "The Magi" },
  { id: 159.0, label_czech: "sv. Valentin", label_english: "St. Valentine" },
  { id: 160.0, label_czech: "sv. Vavřinec", label_english: "St. Lawrence" },
  { id: 161.0, label_czech: "sv. Vilém", label_english: "St. William" },
  {
    id: 162.0,
    label_czech: "sv. Vincent z Pauly",
    label_english: "St. Vincent de Paul",
  },
  { id: 163.0, label_czech: "sv. Zikmund", label_english: "St. Sigismund" },
  {
    id: null,
    label_czech: "Boží Tělo a Panna Maria Bolestná",
    label_english: "Corpus Christi and Our Lady of Sorrows",
  },
  {
    id: null,
    label_czech: "Božího Milosrdenství a sv. Faustyna",
    label_english: "Divine Mercy and St. Faustina Kowalska",
  },
  {
    id: null,
    label_czech: "ke cti Boží, Panny Marie a sv. Václava",
    label_english: "Glory of God, Virgin Mary and St. Wenceslaus",
  },
  {
    id: null,
    label_czech: "Nanebevzetí Panny Marie a sv. Bruno",
    label_english: "Assumption of the Virgin Mary and St. Bruno",
  },
  {
    id: null,
    label_czech: "Nanebevzetí Panny Marie a sv. Cyril a Metoděj",
    label_english: "Assumption of the Virgin Mary and Ss. Cyril and Methodius",
  },
  {
    id: null,
    label_czech: "Nanebevzetí Panny Marie a sv. Jan Křtitel",
    label_english: "Assumption of the Virgin Mary and St. John the Baptist",
  },
  {
    id: null,
    label_czech: "Nanebevzetí Panny Marie a sv. Karel Veliký",
    label_english: "Assumption of the Virgin Mary and St. Charlemagne",
  },
  {
    id: null,
    label_czech: "Nanebevzetí Panny Marie a sv. Václav",
    label_english: "Assumption of the Virgin Mary, St.  Wenceslaus",
  },
  {
    id: null,
    label_czech: "Nanebevzetí Panny Marie, sv. Bruno a sv. Josef",
    label_english: "Assumption of the Virgin Mary, St. Bruno and St. Joseph",
  },
  {
    id: null,
    label_czech: "Nanebevzetí Panny Marie, sv. Vilém a sv. Anežka Římská",
    label_english:
      "Assumption of the Virgin Mary, St. William and St. Agnes of Rome",
  },
  {
    id: null,
    label_czech: "Nanebezvetí Panny Marie a sv. Máří Magdalena",
    label_english: "Assumption of the Virgin Mary and St. Mary Magdalene",
  },
  {
    id: null,
    label_czech: "Narození Panny Marie a sv. Jan Nepomucký",
    label_english:
      "Nativity of the Blessed Virgin Mary and St. John of Nepomuk",
  },
  {
    id: null,
    label_czech: "Nejsvětější Rodička Boží Maria a sv. Jan Křtitel",
    label_english: "Our Most Holy Lady Theotokos and St. John the Baptist",
  },
  {
    id: null,
    label_czech:
      "Nejsvětější Trojice, Matka Boží Loretánská, sv. Václav a sv. Ludmila",
    label_english:
      "Trinity, Mother of God of Loreto, St. Wenceslaus and St. Ludmila of Bohemia",
  },
  {
    id: null,
    label_czech: "Neposkvrněné početí Panny Marie a sv. Bernardin Sienský",
    label_english: "Immaculate Conception and St. Bernardino of Siena",
  },
  {
    id: null,
    label_czech: "Neposkvrněné početí Panny Marie a sv. Ignác",
    label_english: "Immaculate Conception and St. Ignatius of Loyola",
  },
  {
    id: null,
    label_czech: "Panna Maria Karmelská a sv. Jan Křtitel na poušti",
    label_english:
      "Our Lady of Mount Carmel and St. John the Baptist in the desert",
  },
  {
    id: null,
    label_czech: "Panna Maria ustavičné pomoci a sv. Kajetán",
    label_english: "Our Lady of Perpetual Help and St. Cajetan",
  },
  {
    id: null,
    label_czech: "Panna Maria Vítězná a sv. Antonín Paduánský",
    label_english: "Our Lady of Victories and St. Anthony of Padua",
  },
  {
    id: null,
    label_czech: "Panna Maria, svatí Jeroným, Cyril, Metoděj, Vojtěch a Prokop",
    label_english:
      "Virgin Mary, St. Jerome, Ss. Cyril and Methodius, St. Adalbert of Prague and St. Procopius of Sázava",
  },
  {
    id: null,
    label_czech: "Spasitel a sv. Štěpán",
    label_english: "Holy Saviour and St. Stephen ",
  },
  {
    id: null,
    label_czech: "sv. Barbora, sv. František a sv. Bernardin",
    label_english: "St. Barbara, St. Francis and St. Bernardino",
  },
  {
    id: null,
    label_czech: "sv. Benedikt a sv. Norbert",
    label_english: "St. Benedict and St. Norbert of Xanten",
  },
  {
    id: null,
    label_czech: "sv. Benedikt a sv. Vojtěch",
    label_english: "St. Benedict and St. Adalbert of Prague",
  },
  {
    id: null,
    label_czech: "sv. Benedikt, sv. Bonifác a sv. Alexius",
    label_english: "St. Benedict, St. Boniface and St. Alexius",
  },
  {
    id: null,
    label_czech: "sv. Benedikt, sv. Vojtěch a sv. Dionysius z Paříže",
    label_english:
      "St. Benedict, St. Adalbert of Prague and St. Denis of Paris",
  },
  {
    id: null,
    label_czech: "sv. Duch a sv. Václav",
    label_english: "Holy Spirit and St.  Wenceslaus",
  },
  {
    id: null,
    label_czech:
      "sv. Duch, Panna Maria Bohorodička, sv. Václav mučedník a sv. Petr Celestin",
    label_english:
      "Holy Spirit, Virgin Mary Theotokos, St.  Wenceslaus Martyr and St. Peter Celestine",
  },
  {
    id: null,
    label_czech: "sv. Fabián a Šebestián",
    label_english: "Ss. Fabian and Sebastian",
  },
  {
    id: null,
    label_czech: "sv. Ignác a sv. František Xaverský",
    label_english: "St. Ignatius of Loyola and St. Francis Xavier",
  },
  {
    id: null,
    label_czech: "sv. Jakub Větší a sv. Matouš",
    label_english: "St. James the Great and St. Matthew",
  },
  {
    id: null,
    label_czech: "sv. Jan Křtitel a sv. Ivan Poustevník",
    label_english: "St. John the Baptist and St. Ivan the Hermit",
  },
  {
    id: null,
    label_czech: "sv. Jan Křtitel a sv. Jan Evangelista",
    label_english: "St. John the Baptist and St. John the Evangelist",
  },
  {
    id: null,
    label_czech: "sv. Kříž a Panna Maria Sedmibolestná",
    label_english: "Holy Cross and Our Lady of the Seven Sorrows",
  },
  {
    id: null,
    label_czech: "sv. Martin a sv. Prokop",
    label_english: "St. Martin and St. Procopius of Sázava",
  },
  {
    id: null,
    label_czech: "sv. Máří Magdalena a sv. Alžběta",
    label_english: "St. Mary Magdalene and St. Elisabeth",
  },
  {
    id: null,
    label_czech: "sv. Mikuláš a sv. Alžběta",
    label_english: "St. Nicholas and St. Elisabeth",
  },
  {
    id: null,
    label_czech: "sv. Mikuláš a sv. Kateřina",
    label_english: "St. Nicholas and St. Catherine",
  },
  {
    id: null,
    label_czech: "sv. Roch, Šebestián a Rosalie",
    label_english: "St. Roch, St. Sebastian and St. Rosalia",
  },
  {
    id: null,
    label_czech: "sv. Tomáš a sv. Augustin",
    label_english: "St. Thomas and St. Augustine of Hippo ",
  },
  {
    id: null,
    label_czech: "sv. Václav a sv. Karel Veliký",
    label_english: "St.  Wenceslaus and St. Charlemagne",
  },
  {
    id: null,
    label_czech: "sv. Václav a sv. Mikuláš",
    label_english: "St.  Wenceslaus and St. Nicholas",
  },
  {
    id: null,
    label_czech: "sv. Vavřinec a sv. Zdislava",
    label_english: "St. Lawrence and St. Zdislava of Lemberk",
  },
  {
    id: null,
    label_czech: "sv. Vít a sv. Linhart",
    label_english: "St. Vitus and St. Leonard",
  },
  {
    id: null,
    label_czech: "sv. Vít a sv. Modest",
    label_english: "St. Vitus and St. Modestus",
  },
  {
    id: null,
    label_czech: "sv. Vít, Václav a Vojtěch",
    label_english: "St. Vitus,  St.  Wenceslaus and St. Adalbert of Prague",
  },
  {
    id: null,
    label_czech: "Svatí patroni čeští a sv. Anežka",
    label_english: "Patron Saints of Bohemia and St. Agnes of Bohemia",
  },
  {
    id: null,
    label_czech: "Zvěstování Panny Marie a Čtrnáct sv. pomocníků",
    label_english: "Annunciation of Our Lady and Fourteen Holy Helpers",
  },
  {
    id: null,
    label_czech: "Zvěstování Panny Marie a sv. Jan Křtitel",
    label_english: "Annunciation of Our Lady and St. John the Baptist",
  },
  {
    id: null,
    label_czech: "Zvěstování Panny Marie a sv. Tomáš",
    label_english: "Annunciation of Our Lady and St. Thomas",
  },
];
